import React from 'react';
import styles from './spinner.module.scss';
import { Spin, } from 'antd';

export const Spinner = React.memo(() => <div className={styles.loading}><Spin size="large" /></div>);
